export { default } from "./useGroupAttachments";
